var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShieldOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8697 35.5495C20.31 35.7653 19.69 35.7653 19.1303 35.5495C14.7632 33.8727 11.0073 30.9107 8.35896 27.0547C5.71059 23.1986 4.29429 18.6299 4.29712 13.9519V6.70441C4.29712 6.0637 4.55165 5.44921 5.0047 4.99616C5.45776 4.5431 6.07224 4.28857 6.71296 4.28857H33.287C33.9278 4.28857 34.5422 4.5431 34.9955 4.99616C35.4484 5.44921 35.703 6.0637 35.703 6.70441V13.9519C35.7059 18.6299 34.2894 23.1986 31.6412 27.0547C28.9927 30.9107 25.2369 33.8727 20.8697 35.5495Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6 12.8C20.6 12.4686 20.3313 12.2 20 12.2C19.6686 12.2 19.4 12.4686 19.4 12.8V18.5H13.7C13.3686 18.5 13.1 18.7686 13.1 19.1C13.1 19.4314 13.3686 19.7 13.7 19.7H19.4V25.4C19.4 25.7314 19.6686 26 20 26C20.3313 26 20.6 25.7314 20.6 25.4V19.7H26.3C26.6313 19.7 26.9 19.4314 26.9 19.1C26.9 18.7686 26.6313 18.5 26.3 18.5H20.6V12.8Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldOutline);
export default __webpack_public_path__ + "static/media/icon_shield_outline.b2f0e537b0c624a6a648b62ef940db9c.svg";
export { ForwardRef as ReactComponent };